export default __webpack_public_path__ + "static/media/ieee-841.5d6fe257.png";